import { render, staticRenderFns } from "./InvoicePaymentsModal.vue?vue&type=template&id=8d4f6ebc"
import script from "./InvoicePaymentsModal.vue?vue&type=script&lang=js"
export * from "./InvoicePaymentsModal.vue?vue&type=script&lang=js"
import style0 from "./InvoicePaymentsModal.vue?vue&type=style&index=0&id=8d4f6ebc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports